document.addEventListener("DOMContentLoaded", function () {
  function isIE() {
    const ua = window.navigator.userAgent,
      msie = ua.indexOf("MSIE "),
      trident = ua.indexOf("Trident/");
    return msie > 0 || trident > 0;
  }
  if (!isIE()) {
    let setfoot2 = function () {
        (document.querySelector(".parent-sec").style.visibility = "visible"),
          (document.querySelector(".nyg-mask-box").style.visibility =
            "visible"),
          document.querySelectorAll(".foot-item").forEach((item) => {
            item.addEventListener("click", function (e) {
              const index = item.dataset.index;
              (current_foot = parseInt(index) + 1),
                index == 2 &&
                  ((choose_data_roman.foot_2 = item.dataset.type),
                  (choose_data_roman.mount_type =
                    item.dataset.type == "no" ? "Outside" : "Inside"),
                  document
                    .querySelectorAll(".foot-2-item")
                    .forEach((element) => {
                      element.classList.remove("active");
                    }),
                  item.classList.add("active"),
                  document
                    .querySelectorAll(".foot-3-box .base-foot-box")
                    .forEach((i) => (i.style.display = "none")),
                  document
                    .querySelectorAll(`.foot-3-${choose_data_roman.foot_2}-box`)
                    .forEach((i) => (i.style.display = "flex")),
                  document
                    .querySelectorAll(".foot-4-box .base-foot-box")
                    .forEach((i) => (i.style.display = "none")),
                  document
                    .querySelectorAll(`.foot-4-${choose_data_roman.foot_2}-box`)
                    .forEach((i) => (i.style.display = "flex")),
                  (document.querySelectorAll(".MTool-Stepcontent")[
                    index
                  ].innerText = item.dataset.type),
                  document
                    .querySelectorAll(".MTool-Step")
                    [index].classList.add("active")),
                index != 8 &&
                  (document
                    .querySelectorAll(".foot-item-box")
                    .forEach((box) => box.classList.remove("show-item")),
                  document
                    .querySelector(`.foot-${current_foot}-box`)
                    .classList.add("show-item"),
                  (document.getElementById("return-btn").style.display =
                    current_foot > 2 ? "flex" : "none"),
                  (document.querySelectorAll(".MTool-line")[
                    index
                  ].style.border = "1px solid #652A0D"),
                  (document.querySelectorAll(".MTool-Step")[index].style.color =
                    "#652A0D"),
                  window.innerWidth < 769 &&
                    document.querySelector(".MTool-footer").scrollTo({
                      left: document.querySelectorAll(".MTool-Step")[index]
                        .offsetLeft,
                    }),
                  (choose_data_roman.current_foot = current_foot),
                  setLocalMeasure2());
            });
          }),
          document
            .querySelector(".shop-btn")
            .addEventListener("click", function () {
              calMeasurement2();
              document.querySelector(".nyg-mask-box-parent").style.display =
                "none";
              document.querySelector(".parent-sec").style.display = "none";
            }),
          document.querySelectorAll(".MTool-Step").forEach(function (box) {
            box.addEventListener("click", function (e) {
              if (e.target.closest(".active")) {
                let index = e.target
                  .closest(".active")
                  .querySelector("span")
                  .innerText.trim();
                document
                  .querySelectorAll(".foot-item-box")
                  .forEach((box2) => box2.classList.remove("show-item")),
                  document
                    .querySelector(`.foot-${1+Number(index)}-box`)
                    .classList.add("show-item");
                let returnBtn = document.getElementById("return-btn");
                returnBtn &&
                  (returnBtn.style.display = index > 1 ? "flex" : "none");
              }
            });
          }),
          document
            .querySelectorAll(".nyg-mask-content-box input")
            .forEach((item) => {
              item.addEventListener("input", function (event) {
                item.parentNode.nextElementSibling
                  ? (item.parentNode.nextElementSibling.disabled = !(
                      item.value > 0
                    ))
                  : item.parentNode.parentNode.nextElementSibling &&
                    (item.parentNode.parentNode.nextElementSibling.disabled = !(
                      item.value > 0
                    ));
              });
            }),
          document
            .querySelectorAll(".nyg-mask-content-box select.number-select")
            .forEach((item) => {
              item.addEventListener("change", function (event) {
                item.parentNode.nextElementSibling
                  ? (item.parentNode.nextElementSibling.disabled = !(
                      item.value > 0
                    ))
                  : item.parentNode.parentNode.nextElementSibling &&
                    (item.parentNode.parentNode.nextElementSibling.disabled = !(
                      item.value > 0
                    ));
              });
            });
        const ids = [
          "yes-width",
          "no-width-2",
          "yes-height",
          "no-height-2",
          "no-width-1",
          "no-height-1",
        ];
        for (let i = 0; i < ids.length; i++)
          document
            .getElementById(ids[i])
            .addEventListener("submit", function (e) {
              e.preventDefault(), i < 4 ? inputNext(e) : inputNext2(e);
            });
        function inputNext(e) {
          let index = e.target.getAttribute("data-index");
          (current_foot = parseInt(index) + 1),
            index == 3 &&
              (choose_data_roman.foot_2 == "No"
                ? (getNoWidth(),
                  (choose_data_roman.width_input_2 = Number(
                    document.getElementById("width_input_2").value
                  )),
                  (choose_data_roman.width_input_3 = Number(
                    document.getElementById("width_input_3").value
                  )))
                : getYesWidth(),
              (document.querySelectorAll(".MTool-Stepcontent")[1].innerText =
                choose_data_roman.width + `''`),
              document
                .querySelectorAll(".MTool-Step")[1]
                .classList.add("active")),
            index == 4 &&
              (choose_data_roman.foot_2 == "No"
                ? (getNoHeight(),
                  (choose_data_roman.height_input_2 = Number(
                    document.getElementById("height_input_2").value
                  )))
                : getYesHeight(),
              (document.querySelectorAll(".MTool-Stepcontent")[2].innerText =
                choose_data_roman.height + `''`),
              document
                .querySelectorAll(".MTool-Step")[2]
                .classList.add("active"),
              getResult(),
              (current_foot = 8)),
            document.querySelectorAll(".foot-item-box").forEach(function (box) {
              box.classList.remove("show-item");
            }),
            (document.querySelectorAll(".MTool-line")[index - 2].style.border =
              "1px solid #652A0D"),
            (document.querySelectorAll(".MTool-Step")[index - 2].style.color =
              "#652A0D");
          let currentBox = document.querySelector(`.foot-${current_foot}-box`);
          currentBox && currentBox.classList.add("show-item");
          let returnBtn = document.getElementById("return-btn");
          returnBtn && (returnBtn.style.display = index > 1 ? "flex" : "none"),
            (choose_data_roman.current_foot = current_foot),
            setLocalMeasure2();
        }
        function inputNext2(e) {
          let index = e.target.getAttribute("data-index");
          (current_foot = parseInt(index) + 1),
            index == 3 &&
              ((choose_data_roman.yes_width_input_A =
                document.getElementById("yes_width_input_A").value),
              document
                .querySelectorAll(".foot-3-box .base-foot-box")
                .forEach((i) => (i.style.display = "none")),
              document
                .querySelectorAll(".foot-3-No-box-2")
                .forEach((i) => (i.style.display = "flex"))),
            index == 4 &&
              (document
                .querySelectorAll(".foot-4-box .base-foot-box")
                .forEach((i) => (i.style.display = "none")),
              document
                .querySelectorAll(".foot-4-No-box-2")
                .forEach((i) => (i.style.display = "flex")),
              (choose_data_roman.height_input_1 =
                document.getElementById("yes_height_input_A").value)),
            (choose_data_roman.current_foot = current_foot),
            setLocalMeasure2();
        }
        document
          .querySelector(".nyg-mask-inner-box .icon-close")
          .addEventListener("click", function () {
            if (window.location.href.indexOf("measurement-tool") > 0) {
              window.location.href = "https://freshinelife.com/";
            }
          }),
          document
            .getElementById("return-btn")
            .addEventListener("click", function () {
              (choose_data_roman.current_foot =
                choose_data_roman.current_foot > 4
                  ? 4
                  : choose_data_roman.current_foot - 1),
                (current_foot = choose_data_roman.current_foot),
                document
                  .querySelectorAll(".foot-item-box")
                  .forEach((box) => box.classList.remove("show-item")),
                document
                  .querySelector(`.foot-${current_foot}-box`)
                  .classList.add("show-item"),
                current_foot == 2 &&
                  (document.getElementById("return-btn").style.display =
                    "none");
            });
      },
      getResult2 = function () {
        let choose_width = parseInt(choose_data_roman.width),
          choose_height = parseInt(choose_data_roman.height);
        (result.width = parseInt(choose_width)),
          (result.height = parseInt(choose_height)),
          (result.name = choose_data_roman.name),
          (result.width_F = choose_data_roman.width_F),
          (result.height_F = choose_data_roman.height_F),
          (document.querySelector(".shop-btn").dataset.value =
            JSON.stringify(result)),
          ["name"].forEach((item, index) => {
            document.querySelectorAll(".foot-8-box .panel-box span")[
              index
            ].textContent = choose_data_roman[item];
          }),
          (document.querySelector(".foot-8-box .foot-pc-part img").src =
            choose_data_roman.foot_2 == "No"
              ? "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-2-Mount_Type-Outside.webp"
              : "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/measure-2-Mount_Type-Inside.webp"),
          (document.querySelector(".foot-8-box .foot-img-container img").src =
            choose_data_roman.foot_2 == "No"
              ? "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/mbmeasure-outside.webp"
              : "https://cdn.shopify.com/s/files/1/0901/6888/5527/files/mbmeasure-inside.webp"),
          (document.querySelector(
            ".foot-8-box .panel-box[type='size'] span"
          ).textContent = `${result.width} ${result.width_F}"W x ${result.height}  ${result.height_F}"H`),
          (document.querySelector(
            ".foot-8-box .panel-box[type='header'] span"
          ).textContent = `${choose_data_roman.mount_type}`),
          (choose_data_roman.r_width = result.width),
          (choose_data_roman.r_height = result.height),
          (choose_data_roman.r_qty = result.qty),
          setLocalMeasure2(),
          document
            .querySelector(".shop-btn")
            .addEventListener("click", function () {
              window.location.href.indexOf("measurement-tool") > 0
                ? (window.location.href =
                    "https://freshinelife.com/collections/custom-curtains")
                : (choose_data_roman.room_name =
                    document.querySelector(".room-name-input").value ||
                    "baseRoom");
            }),
          document.querySelector(".foot-8-box").classList.add("show-item");
        document
          .querySelector(".foot-8-box .re-btn")
          .addEventListener("click", function () {
            document
              .querySelectorAll(".foot-item-box")
              .forEach((box) => box.classList.remove("show-item")),
              document
                .querySelectorAll(".MTool-Step")
                .forEach((box) => box.classList.remove("active")),
              document
                .querySelectorAll(".MTool-Stepcontent")
                .forEach((box) => (box.innerText = "")),
              document.querySelector(".foot-2-box").classList.add("show-item"),
              document.querySelector(".MTool-Step").classList.add("active");
          });
      },
      calMeasurement2 = async function () {
        document.querySelector(
          `input[key="po_Mount Type"][value="${choose_data_roman.mount_type} Mount"]`
        ) &&
          !document.querySelector(
            `input[key="po_Mount Type"][value="${choose_data_roman.mount_type} Mount"]`
          ).checked &&
          document
            .querySelector(
              `input[key="po_Mount Type"][value="${choose_data_roman.mount_type} Mount"]`
            )
            .click();
        updateInput(
          choose_data_roman.width,
          choose_data_roman.width_F,
          document.querySelector(".size-details-wrapper:first-child")
        );
        await sleep(200);
        updateInput(
          choose_data_roman.height,
          choose_data_roman.height_F,
          document.querySelector(".size-details-wrapper:last-child")
        );
      },
      setLocalMeasure2 = function () {
        localStorage.setItem(
          "baseRoomRoman",
          JSON.stringify(choose_data_roman)
        );
      },
      getLocalMeasure2 = function () {
        return JSON.parse(localStorage.getItem("baseRoomRoman"));
      },
      initOption = function () {
        const fragment = document.createDocumentFragment();
        const fragment2 = document.createDocumentFragment();

        for (let i = 20; i <= 118; i++) {
          const option = new Option(i, i);
          fragment.appendChild(option);
        }
        for (let i = 22; i <= 90; i++) {
          const option = new Option(i, i);
          fragment2.appendChild(option);
        }
         document.querySelectorAll(".foot-3-box .number-select").forEach((select) => {
          select.appendChild(fragment2.cloneNode(true));
        });
        document.querySelectorAll(".foot-4-box .number-select").forEach((select) => {
          select.appendChild(fragment.cloneNode(true));
        });
      },
      initFOption = function () {
        const fragment = document.createDocumentFragment();
        let arr = ["0", "1/8", "1/4", "3/8", "1/2", "5/8", "3/4"];
        for (let i = 0; i < arr.length; i++) {
          const option = new Option(arr[i], arr[i]);
          fragment.appendChild(option);
        }
        document.querySelectorAll(".F-select").forEach((select) => {
          select.appendChild(fragment.cloneNode(true));
        });
      },
      initStepLocal2 = function () {
        let localData = getLocalMeasure2();
        if (localData) {
          choose_data_roman = localData;
          if (document.querySelector('input[key="po_Header"]:checked')) {
            choose_data_roman.name = document.querySelector(
              'input[key="po_Header"]:checked'
            ).value;
          }
          for (let i = 1; i < localData.current_foot; i++) {
            initStepNext2(i, choose_data_roman);
          }

          document
            .querySelectorAll(".foot-item-box")
            .forEach((box) => box.classList.remove("show-item")),
            document.querySelector(`.foot-2-box`).classList.add("show-item");
          document
            .querySelectorAll(".nyg-mask-content-box input")
            .forEach((item) => {
              item.parentNode.nextElementSibling
                ? (item.parentNode.nextElementSibling.disabled = !(
                    item.value > 0
                  ))
                : item.parentNode.parentNode.nextElementSibling &&
                  (item.parentNode.parentNode.nextElementSibling.disabled = !(
                    item.value > 0
                  ));
            });
        } else {
          if (document.querySelector('input[key="po_Header"]:checked')) {
            choose_data_roman.name = document.querySelector(
              'input[key="po_Header"]:checked'
            ).value;
            initStepNext2(1, choose_data_roman);
          }
        }
      },
      initStepNext2 = function (index, choose_data_roman2) {
        index == 1 &&
          (document.querySelectorAll(".foot-2-item").forEach((element) => {
            element.classList.remove("active");
          }),
          document
            .querySelectorAll(".foot-3-box .base-foot-box")
            .forEach((i) => (i.style.display = "none")),
          document
            .querySelectorAll(`.foot-3-${choose_data_roman2.foot_2}-box`)
            .forEach((i) => (i.style.display = "flex")),
          document
            .querySelectorAll(".foot-4-box .base-foot-box")
            .forEach((i) => (i.style.display = "none")),
          document
            .querySelectorAll(`.foot-4-${choose_data_roman2.foot_2}-box`)
            .forEach((i) => (i.style.display = "flex")),
          (document.querySelectorAll(".MTool-Stepcontent")[0].innerText =
            choose_data_roman2.foot_2 == "no" ? "Outside" : "Inside")),
          index == 2 &&
            (choose_data_roman2.foot_2 == "No"
              ? ((document.getElementById("no_width_input_A").value =
                  choose_data_roman2.width),
                (document.getElementById("width_input_2").value =
                  choose_data_roman2.width_input_2),
                (document.getElementById("width_input_3").value =
                  choose_data_roman2.width_input_3))
              : ((document.getElementById("yes_width_input_A").value =
                  choose_data_roman2.width),
                showContinueBtn2(document.getElementById("yes_width_input_A"))),
            (document.querySelectorAll(".MTool-Stepcontent")[1].innerText =
              choose_data_roman2.width + `''`)),
          index == 3 &&
            (choose_data_roman2.foot_2 == "No"
              ? ((choose_data_roman2.height =
                  Number(choose_data_roman2.height_input_1) +
                  Number(document.getElementById("height_input_2").value)),
                (document.getElementById("height_input_2").value =
                  choose_data_roman2.height_input_2))
              : ((document.getElementById("yes_height_input_A").value =
                  choose_data_roman2.height),
                showContinueBtn2(
                  document.getElementById("yes_height_input_A")
                )),
            (document.querySelectorAll(".MTool-Stepcontent")[2].innerText =
              choose_data_roman2.height + `''`)),
         index<4&&document
            .querySelectorAll(".MTool-Step")
            [index].classList.add("active"),
          (document.getElementById("return-btn").style.display =
            choose_data_roman2.current_foot > 1 ? "flex" : "none");
      },
      getListMinMax = function (idList, type) {
        const ids = idList;
        let resultId = null;
        let resultVal = null;

        ids.forEach((id) => {
          const element = document.getElementById(id);
          if (element) {
            const num =
              parseFloat(element.value) +
              parseFloat(element.nextElementSibling.value);
            if (!isNaN(num)) {
              if (resultVal === null) {
                resultVal = num;
                resultId = id;
              } else {
                if (type === "min" && num < resultVal) {
                  resultVal = num;
                  resultId = id;
                } else if (type === "max" && num > resultVal) {
                  resultVal = num;
                  resultId = id;
                }
              }
            }
          }
        });
        return resultId;
      },
      getNoHeight = function () {
        let resultId = getListMinMax(
          ["no_height_input_A", "no_height_input_B", "no_height_input_C"],
          "max"
        );
        choose_data_roman.height =
          Number(document.getElementById(`${resultId}`).value) +
          Number(document.getElementById("height_input_2").value);
        choose_data_roman.height_F = document.getElementById(
          `${resultId}`
        ).nextElementSibling.value;
      },
      getYesHeight = function () {
        let resultId = getListMinMax(
          ["yes_height_input_A", "yes_height_input_B", "yes_height_input_C"],
          "max"
        );
        choose_data_roman.height = document.getElementById(`${resultId}`).value;
        choose_data_roman.height_F = document.getElementById(
          `${resultId}`
        ).nextElementSibling.value;
      },
      getYesWidth = function () {
        let resultId = getListMinMax(
          ["yes_width_input_A", "yes_width_input_B", "yes_width_input_C"],
          "min"
        );
        choose_data_roman.width = document.getElementById(`${resultId}`).value;
        choose_data_roman.width_F = document.getElementById(
          `${resultId}`
        ).nextElementSibling.value;
      },
      getNoWidth = function () {
        let resultId = getListMinMax(
          ["no_width_input_A", "no_width_input_B", "no_width_input_C"],
          "max"
        );
        choose_data_roman.width =
          Number(document.getElementById(`${resultId}`).value) +
          Number(document.getElementById("width_input_2").value) +
          Number(document.getElementById("width_input_3").value);
        choose_data_roman.width_F = document.getElementById(
          `${resultId}`
        ).nextElementSibling.value;
      },
      updateInput = async function (width1, width2, target) {
        let widthSelect = target.querySelectorAll(
          ".po-select-dropdown-thumbnail"
        )[0];
        let widthSelect2 = target.querySelectorAll(
          ".po-select-dropdown-thumbnail"
        )[1];
        if (
          widthSelect &&
          widthSelect.querySelector(
            `.po-dropdown-option[data-value="${width1}"]`
          )
        ) {
          widthSelect
            .querySelector(`.po-dropdown-option[data-value="${width1}"]`)
            .click();
          await sleep(200);
          widthSelect
            .querySelector(`.po-dropdown-option[data-value="${width1}"]`)
            .click();
        }
        await sleep(200);
        let w2 =  width2;
        if (
          widthSelect2 &&
          widthSelect2.querySelector(`.po-dropdown-option[data-value="${w2}"]`)
        ) {
          widthSelect2
            .querySelector(`.po-dropdown-option[data-value="${w2}"]`)
            .click();
          await sleep(200);

          widthSelect2
            .querySelector(`.po-dropdown-option[data-value="${w2}"]`)
            .click();
        }
      },
      showContinueBtn2 = function (target) {
        if (target.value > 0) {
          target.parentNode.nextElementSibling
            ? (target.parentNode.nextElementSibling.disabled = !1)
            : target.parentNode.parentNode.nextElementSibling &&
              (target.parentNode.parentNode.nextElementSibling.disabled = !1);
        }
      };
    var setfoot = setfoot2,
      getResult = getResult2,
      calMeasurement = calMeasurement2,
      setLocalMeasure = setLocalMeasure2,
      getLocalMeasure = getLocalMeasure2,
      initStepLocal = initStepLocal2,
      initStepNext = initStepNext2,
      showContinueBtn = showContinueBtn2;
    let choose_data_roman = {
        width: 0,
        yes_width_A: 0,
        yes_width_B: 0,
        yes_width_C: 0,
        yes_width_A_F: 0,
        yes_width_B_F: 0,
        yes_width_C_F: 0,
        no_width_A: 0,
        no_width_B: 0,
        no_width_C: 0,
        width_F: 0,
        height_F: 0,
        width1: 0,
        width_input_2: 0,
        width_input_3: 0,
        height: 0,
        height_input_1: 0,
        bottom: 0,
        current_foot: 0,
        room_name: "baseRoom",
        mount_type: "inside",
      },
      current_foot = 2,
      result = {};
    setfoot2(), initOption(), initFOption(), initStepLocal2();
    return;
  }
});
